/* Earthling cart upsells: bundle & save (standalone) */
(function () {
  var TH = (document.documentElement.lang || '').toLowerCase().indexOf('th') === 0;
  var THB = function (cents) { return '฿' + (cents / 100).toLocaleString('en-US', { maximumFractionDigits: 2 }).replace(/\.00$/, ''); };
  function qs(s, r) { return (r || document).querySelector(s); }
  var CAP_SINGLES = { 53000909685058: 1, 53001454387522: 1, 53001572811074: 1 };
  var BUNDLE_V1 = 54526198513986, BUNDLE_PRICE = 342500, BUNDLE_SAVE = 60500;
  var STACK_V1 = 53016399413570, STACK_PRICE = 403000, STACK_SAVE = 29500;
  var GUMMIES = [53002498933058, 53002498965826, 53002498998594];
  var TIER_UP = {
    52990202609986: [52990202642754, 170000, 10000, 'Focus Seltzer · 2 boxes', 'โฟกัสเซลทเซอร์ 2 กล่อง'],
    52990202642754: [52990202675522, 240000, 30000, 'Focus Seltzer · 3 boxes', 'โฟกัสเซลทเซอร์ 3 กล่อง'],
    53002498933058: [53002498965826, 162000, 18000, 'Gummies · 2 bags', 'กัมมี่ 2 ถุง'],
    53002498965826: [53002498998594, 229500, 40500, 'Gummies · 3 bags', 'กัมมี่ 3 ถุง'],
    53000909685058: [53000909717826, 248400, 27600, "Lion's Mane caps · 2 bottles", 'เห็ดหัวลิง 2 ขวด'],
    53000909717826: [53000909750594, 351900, 62100, "Lion's Mane caps · 3 bottles", 'เห็ดหัวลิง 3 ขวด'],
    53001454387522: [53001454420290, 216000, 24000, 'Reishi caps · 2 bottles', 'เห็ดหลินจือ 2 ขวด'],
    53001454420290: [53001454453058, 306000, 54000, 'Reishi caps · 3 bottles', 'เห็ดหลินจือ 3 ขวด'],
    53001572811074: [53001572843842, 261000, 29000, 'Cordyceps caps · 2 bottles', 'ถั่งเช่า 2 ขวด'],
    53001572843842: [53001572876610, 369800, 65200, 'Cordyceps caps · 3 bottles', 'ถั่งเช่า 3 ขวด'],
    54526198513986: [54526198546754, 604500, 80500, 'Capsule bundle × 2', 'ชุดแคปซูล × 2']
  };
  var CDN='https://cdn.shopify.com/s/files/1/0840/8121/3762/files/';
  var IMG = {
    52990202642754: 'focussetzer.png', 52990202675522: 'focussetzer.png',
    53002498965826: 'MushroomGummies_2.png', 53002498998594: 'MushroomGummies_2.png',
    53000909717826: 'earthling-lions-mane-capsules-bottle.png', 53000909750594: 'earthling-lions-mane-capsules-bottle.png',
    53001454420290: 'earthling-reishi-capsules-bottle.png', 53001454453058: 'earthling-reishi-capsules-bottle.png',
    53001572843842: 'earthling-cordyceps-capsules-bottle.png', 53001572876610: 'earthling-cordyceps-capsules-bottle.png',
    54526198513986: '7_63e55be3-0718-4527-84ae-fc964b9c9338.png', 54526198546754: '7_63e55be3-0718-4527-84ae-fc964b9c9338.png',
    53016399413570: 'ultimatebundleproductimage.png'
  };
  function row(label, price, save, action) {
    var im = IMG[action.add] ? '<img src="' + CDN + IMG[action.add] + '?width=120" alt="" style="width:44px;height:44px;object-fit:contain;border-radius:10px;background:#FFFDF8;flex-shrink:0;">' : '';
    return '<div style="display:flex;align-items:center;gap:10px;padding:8px 0;">' + im +
      '<div style="flex:1;min-width:0;"><div style="font-size:13px;font-weight:700;color:#16321F;line-height:1.3;">' + label + '</div>' +
      '<div style="font-size:12.5px;color:#3A4A38;">' + THB(price) + ' <span style="color:#0B5A2B;font-weight:800;">' + (TH ? 'ประหยัด ' : 'save ') + THB(save) + '</span></div></div>' +
      '<button data-em-upsell=\'' + JSON.stringify(action) + '\' style="border:none;background:#0B5A2B;color:#FBF6EC;font-family:inherit;font-size:12.5px;font-weight:700;border-radius:99px;padding:8px 16px;cursor:pointer;white-space:nowrap;flex-shrink:0;">' + (action.zero.length > 1 ? (TH ? 'สลับ' : 'Switch') : (TH ? 'อัปเกรด' : 'Upgrade')) + '</button></div>';
  }
  function build(cart) {
    var rows = [], byVariant = {};
    cart.items.forEach(function (it) { byVariant[it.variant_id] = it; });
    var capKeys = [];
    Object.keys(CAP_SINGLES).forEach(function (v) { var it = byVariant[v]; if (it && it.quantity === 1) capKeys.push(it.key); });
    if (capKeys.length >= 2 && !byVariant[BUNDLE_V1]) {
      rows.push(row(TH ? 'สลับเป็นชุดแคปซูลรวม 3 ขวด' : 'Switch to the 3-bottle capsule bundle', BUNDLE_PRICE, BUNDLE_SAVE, { zero: capKeys, add: BUNDLE_V1 }));
    }
    var bundleLine = byVariant[BUNDLE_V1];
    var hasGummies = GUMMIES.some(function (v) { return byVariant[v]; });
    if (rows.length < 2 && bundleLine && bundleLine.quantity === 1 && !hasGummies && !byVariant[STACK_V1]) {
      rows.push(row(TH ? 'สลับเป็น Earthling Stack (แถมกัมมี่ฟรี)' : 'Switch to the Earthling Stack (adds gummies)', STACK_PRICE, STACK_SAVE, { zero: [bundleLine.key], add: STACK_V1 }));
    }
    var ups = [];
    cart.items.forEach(function (it) {
      var t = TIER_UP[it.variant_id];
      if (t && it.quantity === 1) ups.push({ save: t[2], html: row(TH ? t[4] : t[3], t[1], t[2], { zero: [it.key], add: t[0] }) });
    });
    ups.sort(function (a, b) { return b.save - a.save; });
    while (rows.length < 2 && ups.length) rows.push(ups.shift().html);
    if (!rows.length) return '';
    return '<div style="margin:0 0 12px;background:#F1EAD8;border-radius:16px;padding:10px 14px;"><div style="font-size:11px;font-weight:800;letter-spacing:1px;color:#0B5A2B;padding-bottom:2px;">' + (TH ? 'จับคู่ประหยัด' : 'BUNDLE & SAVE') + '</div>' + rows.join('') + '</div>';
  }
  var GIFT_MIN = 90000; // ฿900
  var GIFT_V = 53002498933058; // gummies 1 Bag (90 gummies)
  var GIFT_CODE = 'GF824881';
  var GIFT_UNLOCK_KEY = 'em_gift_unlocked';
  (function () {
    try {
      var href = location.href;
      if (/[?&]gift_unlocked=1/.test(href) || href.toUpperCase().indexOf(GIFT_CODE) > -1 || document.cookie.indexOf('discount_code=' + GIFT_CODE) > -1) {
        localStorage.setItem(GIFT_UNLOCK_KEY, '1');
      }
    } catch (e) {}
  })();
  function giftUnlocked() { try { return localStorage.getItem(GIFT_UNLOCK_KEY) === '1'; } catch (e) { return false; } }
  function giftLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.variant_id === GIFT_V && it.properties && it.properties._gift) return it;
    }
    return null;
  }
  function giftBar(cart, gl) {
    var eligible = cart.total_price - (gl ? gl.final_line_price : 0);
    var pct = Math.min(100, Math.round(eligible / GIFT_MIN * 100));
    var left = GIFT_MIN - eligible;
    var sub = TH ? 'กัมมี่ Focus & Flow 90 เม็ด (มูลค่า ฿900) ฟรี เมื่อสั่งครบ ฿900' : 'A Focus & Flow gummies bag (฿900 value), free on any order over ฿900';
    var head = left > 0
      ? (TH ? 'อีก <strong style="color:#0B5A2B;">' + THB(left) + '</strong> รับของขวัญฟรี 🎁' : '<strong style="color:#0B5A2B;">' + THB(left) + '</strong> away from a FREE gift 🎁')
      : (TH ? '🎁 รับกัมมี่ฟรีแล้ว!' : '🎁 Free gummies added to your order!');
    return '<div style="margin:0 0 10px;background:#FFFDF8;border:1px solid rgba(11,90,43,0.12);border-radius:16px;padding:11px 14px;">' +
      '<div style="display:flex;align-items:center;gap:10px;">' +
      '<img src="https://cdn.shopify.com/s/files/1/0840/8121/3762/files/MushroomGummies_2.png?width=120" alt="" style="width:38px;height:38px;object-fit:contain;flex-shrink:0;">' +
      '<div style="flex:1;min-width:0;"><div style="font-size:13px;font-weight:700;color:#16321F;">' + head + '</div>' +
      '<div style="font-size:11px;color:#6D7A63;font-weight:600;">' + sub + '</div></div></div>' +
      '<div style="height:6px;background:#F1EAD8;border-radius:99px;margin-top:8px;overflow:hidden;"><div style="height:100%;width:' + pct + '%;background:linear-gradient(90deg,#0B5A2B,#bef879);border-radius:99px;transition:width .4s;"></div></div></div>';
  }
  function rerenderItems() {
    if (window.emFetchCart) { window.emFetchCart().then(refresh); } else { refresh(); }
  }
  var giftBusy = false;
  function syncGift(cart) {
    if (giftBusy) return;
    var gl = giftLine(cart);
    var eligible = cart.total_price - (gl ? gl.final_line_price : 0);
    if (giftUnlocked() && eligible >= GIFT_MIN && !gl) {
      giftBusy = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: GIFT_V, quantity: 1, properties: { _gift: 'free-gummies-900' } }) })
        .then(function () { giftBusy = false; rerenderItems(); }).catch(function () { giftBusy = false; });
    } else if (gl && eligible < GIFT_MIN) {
      giftBusy = true;
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: gl.key, quantity: 0 }) })
        .then(function () { giftBusy = false; rerenderItems(); }).catch(function () { giftBusy = false; });
    }
  }
  var pending = false;
  function refresh() {
    if (pending) return; pending = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      pending = false;
      var form = qs('#em-cart-drawer form[action="/checkout"]');
      if (!form) return;
      var slot = qs('#em-upsell-slot');
      if (!slot) { slot = document.createElement('div'); slot.id = 'em-upsell-slot'; form.parentNode.insertBefore(slot, form); }
      var gl = giftLine(cart);
      var html = cart.items.length ? ((giftUnlocked() || gl ? giftBar(cart, gl) : '') + build(cart)) : '';
      var had = !!slot.innerHTML, has = !!html;
      slot.innerHTML = html;
      if (has && !had && window.clarity) try { window.clarity('event', 'cart_upsell_shown'); } catch (e) {}
      syncGift(cart);
    }).catch(function () { pending = false; });
  }
  document.addEventListener('click', function (e) {
    var u = e.target.closest ? e.target.closest('[data-em-upsell]') : null;
    if (!u) return;
    var act = JSON.parse(u.getAttribute('data-em-upsell'));
    if (window.clarity) try { window.clarity('event', 'cart_upsell_click'); window.clarity('set', 'cart_upsell', 'clicked'); } catch (e) {}
    u.disabled = true; u.textContent = '…';
    var chain = Promise.resolve();
    act.zero.forEach(function (key) {
      chain = chain.then(function () {
        return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) });
      });
    });
    chain.then(function () {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: act.add, quantity: 1, properties: { _upsell: 'bundle-save' } }) });
    }).then(function () {
      if (window.emOpenCart) window.emOpenCart(); else refresh();
    }).catch(function () { refresh(); });
  });
  function init() {
    var list = document.getElementById('em-cart-items');
    if (!list) return setTimeout(init, 400);
    try { new MutationObserver(refresh).observe(list, { childList: true }); } catch (e) { setInterval(refresh, 2500); }
    refresh();
  }
  init();
})();
